// Which hostnames report, and what a page is called. A GA4 measurement id is
// public (it ships in the page), so it lives here, keyed by hostname: only the
// hosts in the map send anything; the dev site, localhost, Storybook and the
// headless checks stay silent until a stream is added for them.
import { REVIEW_ROUTE } from '@chess/api-games';

/** The GA4 web streams, by hostname. To report the dev site too, add its stream's id under `dev.chess.cntnl.com`. */
export const STREAMS: Readonly<Record<string, string>> = {
  'chess.cntnl.com': 'G-H5Z2CJWWNC',
};

/** The measurement id for a hostname: exact match, case-insensitive; undefined for every other host. */
export function measurementIdFor(hostname: string): string | undefined {
  return STREAMS[hostname.trim().toLowerCase()];
}

/** The review route's fixed part, `/review`: the rest of the address names a user and a game. */
const REVIEW_BASE = REVIEW_ROUTE.slice(0, REVIEW_ROUTE.indexOf('/:'));

/**
 * What a path is reported as: a review's game address is cut to `/review`
 * (the route is `/review/{website}/{username}/{date}/{id}`, so no username
 * or id leaves the browser); a query or fragment is dropped; any other path
 * passes unchanged.
 */
export function pagePathOf(pathname: string): string {
  const path = pathname.split(/[?#]/)[0] || '/';
  return path === REVIEW_BASE || path.startsWith(`${REVIEW_BASE}/`) ? REVIEW_BASE : path;
}

/** Whether GA's DebugView is wanted: `?ga_debug=1` in the address, or `ga_debug` set to `1` in local storage. */
export function debugWanted(search: string, stored: string | null | undefined): boolean {
  return new URLSearchParams(search).get('ga_debug') === '1' || stored === '1';
}
